import PropTypes from 'prop-types';

import { LayoutPageSidebarWrapper } from 'app/layout/components/page/Sidebar/Wrapper';
import { SidebarCollapseProvider } from 'app/layout/context/drawer';

import { ParticipantCopyInfo } from 'features/participants/components/ParticipantCopyInfo';

export const LayoutPageSidebar = ({ children }) => {
  return (
    <SidebarCollapseProvider>
      <LayoutPageSidebarWrapper>
        {children}
        <ParticipantCopyInfo />
      </LayoutPageSidebarWrapper>
    </SidebarCollapseProvider>
  );
};

LayoutPageSidebar.propTypes = { children: PropTypes.node.isRequired };
